import { InjectionToken, Injector, Type } from '@angular/core';
import { PersistencyTypes } from '@common-modules/common-persistency/persistency-types';
import { DynamicLayoutItemSettings } from './models/dynamic-layout-item-settings';
import { DynamicLayoutSettings } from './models/dynamic-layout-settings';
export * from './dynamic-layout.tokens';

export const DYNAMIC_LAYOUT_EXTERNAL_SETTINGS = new InjectionToken<DynamicLayoutExternalSettings>(
  'dynamic_layout_external_settings'
);

export class DynamicLayoutExtendHeadersSettings {
  component: Type<any>;
  shouldRender?: (
    itemSettings: DynamicLayoutItemSettings,
    settings?: DynamicLayoutSettings
  ) => boolean;
  flagName: string;
  position?: 'before' | 'after' = 'after';
  featureInjectorFn?: () => Injector;
}

export class DynamicLayoutExternalSettings {
  persistency: PersistencyTypes;
  extendHeaders?: DynamicLayoutExtendHeadersSettings[];
}
